<template>
  <div class="nav-margin">
    <navigation :updatedAccountLogo="updatedAccountLogo" :premium-gate-enabled="premiumGateEnabled"></navigation>
    <div>
      <b-tabs
          ref="accountTabs"
          @input="onTabChanged"
          active-nav-item-class="font-weight-normal border-bottom border-success border-left-0 border-right-0 border-top-0 text-success"
          active-tab-class="text-success"
          nav-class="bg-white pt-0 d-flex"
          content-class="container-fluid px-0"
          justified
          :class="{'premium-gated': premiumGateEnabled}"
      >
        <b-tab title="Organization" active>
          <template #title>
            <span class="font-weight-normal w-50">Organization</span>
          </template>
          <accountInformation v-on:uploadAccountLogo="updateAccountLogo($event)"/>
        </b-tab>
        <b-tab title="Branding">
          <template #title>
            <span class="font-weight-normal">Branding</span>
          </template>
          <reviewScreenVersions />
          <styleEditor/>
          <accountLabels/>
        </b-tab>
        <b-tab title="Properties">
          <template #title>
            <span class="font-weight-normal">Properties</span>
          </template>
          <div>
            <accountProperties/>
          </div>
        </b-tab>
        <b-tab title="Integrations" lazy>
          <template #title>
            <span class="font-weight-normal">Integrations</span>
          </template>
          <div>
            <zapierConnections :premium-gate-enabled="premiumGateEnabled"/>
          </div>
        </b-tab>
      </b-tabs>
      <modalGatedFeatures :feature-key="premiumModalKey" :modalId="MODAL_NAMES.GATED_FEATURES_MODAL" :shouldShowMaybeLater="false"/>
    </div>
  </div>
</template>

<script>
import accountInformation from "../components/settings/setting-accountInformation.vue";
import accountUsers from "../components/settings/setting-accountUsers.vue";
import accountChecklists from "../components/settings/setting-accountChecklists.vue";
import zapierConnections from "../components/settings/setting-zapierConnections.vue";
import reviewScreenVersions from "../components/settings/setting-reviewScreenVersions.vue";
import styleEditor from "../components/settings/setting-styleEditor.vue";
import modalDeleteItem from "../components/modals/modal-confirmation.vue";
import accountLabels from "../components/settings/setting-accountLabels";
import accountProperties from "../components/settings/setting-accountProperties";
import { updateFaviconAndTitle } from "../utils/helpers"
import modalGatedFeatures from "../components/modals/modal-non-premium-integration-screen.vue";
import { PLAN_SKU_TYPES, MODAL_NAMES, PREMIUM_FEATURES_KEYS, ACCOUNT_SETTING_TABS } from '../utils/constants';

const { FREE_PLAN, SUSPENDED_PLAN, TRIAL_PLAN } = PLAN_SKU_TYPES

export default {
  components: {
    accountInformation,
    accountUsers,
    accountProperties,
    accountChecklists,
    modalDeleteItem,
    zapierConnections,
    reviewScreenVersions,
    styleEditor,
    accountLabels,
    modalGatedFeatures,
  },
  data() {
    return {
      updatedAccountLogo: null,
      premiumModalKey: "",
      FREE_PLAN,
      SUSPENDED_PLAN,
      TRIAL_PLAN,
      MODAL_NAMES,
      PREMIUM_FEATURES_KEYS,
      premiumGateEnabled: false,
      ACCOUNT_SETTING_TABS
    }
  },
  async mounted() {
    await this.$A.GetCurAccountData();
  },
  computed: {
    isFreeUser() {
      const currentSubscription = _.get(this.$A, 'Auth.account.subscriptionState', []);
      return currentSubscription.sku === FREE_PLAN || currentSubscription.sku === SUSPENDED_PLAN || currentSubscription.sku === TRIAL_PLAN;
    },
  },
  methods: {
    updateAccountLogo(logo) {
      updateFaviconAndTitle({ accountLogo: logo });

      this.updatedAccountLogo = logo;
    },
    onTabChanged(tabIndex) {
      if (!this.isFreeUser || tabIndex !== ACCOUNT_SETTING_TABS.INTEGRATION) {
        this.$bvModal.hide(MODAL_NAMES.GATED_FEATURES_MODAL);
        this.premiumGateEnabled = false;
      }
      else {
        this.premiumModalKey = PREMIUM_FEATURES_KEYS.INTEGRATION;
        this.$bvModal.show(MODAL_NAMES.GATED_FEATURES_MODAL);
        this.premiumGateEnabled = true;
      }
    }
  }
};
</script>

<style scoped>

::v-deep .nav-tabs .nav-link {
  margin-bottom: -2px;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

::v-deep .nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 100px;
  padding-right: 100px;
  margin-bottom: 0;
  list-style: none;
}

::v-deep .nav > li > a {
  position: relative;
  display: block;
  padding: 19px 15px;
  font-weight: bold;
  color: #444444;
}

::v-deep .premium-gated.tabs > div:first-child {
  z-index: 20002;
  position: relative;
}

@media (max-width: 750px) {
  ::v-deep .nav {
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;
    list-style: none;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}

@media (min-width: 1500px)  and (max-width: 1700px) {
  ::v-deep .nav {
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;
    list-style: none;
    padding-left: 100px !important;
    padding-right: 100px !important;
  }
}

@media (min-width: 1700px) and (max-width: 1998px) {
  ::v-deep .nav {
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;
    list-style: none;
    padding-left: 300px !important;
    padding-right: 300px !important;
  }
}

@media (min-width: 1998px) and (max-width: 2194px) {
  ::v-deep .nav {
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;
    list-style: none;
    padding-left: 500px !important;
    padding-right: 500px !important;
  }
}

@media (min-width: 2194px) and (max-width: 4000px) {
  ::v-deep .nav {
    display: flex;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;
    list-style: none;
    padding-left: 600px !important;
    padding-right: 600px !important;
  }
}


</style>
